export default function calculNombreCritere(criteresRecherche, banCritereKey) {
  return Object.keys(criteresRecherche).filter(critereKey => {
    return (!banCritereKey.find(banCritere => banCritere === critereKey)
      && ((Array.isArray(criteresRecherche[critereKey])
        && criteresRecherche[critereKey].length > 0)
        || (!Array.isArray(criteresRecherche[critereKey])
          && criteresRecherche[critereKey])));
  }).length;
}
